import { Component } from '@angular/core';

@Component({
  selector: 'app-cbc-exchange-filter-select',
  standalone: false,
  templateUrl: './cbc-exchange-filter-select.component.html',
  styleUrl: './cbc-exchange-filter-select.component.scss'
})
export class CbcExchangeFilterSelectComponent {

}
